module.exports = __webpack_public_path__ + "img/fancy-list-3.512e8bc.png";